import Constants from 'arts/config/constants';
import { buildWorksReducer } from 'arts/config/works_loader_actions';

const works = buildWorksReducer(Constants.Works);

export default works;
export * from './proptypes';
